import {
  Container,
  createStyles,
  ListItemText,
  makeStyles,
  Theme,
} from '@material-ui/core'
import { Fragment, ReactNode, useCallback } from 'react'

type SettingsHeaderProps = {
  title: string
  children?: ReactNode
  className?: string
  containerMaxWidth?: 'lg' | 'md' | 'sm'
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    settingsHeaderRoot: {
      padding: theme.spacing(2),
      width: '100%',
      display: 'flex',
      // justifyContent: 'center',
      borderBottom: `4px solid ${theme.palette.divider}`,
      '& .MuiListItemText-root': {
        flex: 'none !important',
      },
    },
  })
)

export const SettingsHeader = (props: SettingsHeaderProps) => {
  const cn = useStyles()

  const Header = useCallback(
    () => (
      <ListItemText
        primary={props.title}
        primaryTypographyProps={{ variant: 'h5' }}
        secondary={props.children}
      />
    ),
    [props.children, props.title]
  )

  const ContainerEl = ({ children }) =>
    props.containerMaxWidth ? (
      <Container maxWidth={props.containerMaxWidth}>{children}</Container>
    ) : (
      <Fragment>{children}</Fragment>
    )

  return (
    <div className={`${cn.settingsHeaderRoot} ${props.className}`}>
      <ContainerEl>
        <Header />
      </ContainerEl>
    </div>
  )
}
